
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ranking/articles/[year]/[month]",
      function () {
        return require("private-next-pages/ranking/articles/[year]/[month].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ranking/articles/[year]/[month]"])
      });
    }
  